module.exports = __webpack_public_path__ + "img/icon-white-live-match.dece248f.svg";